import { render, staticRenderFns } from "./resport.vue?vue&type=template&id=5b2f69c4&scoped=true&"
import script from "./resport.vue?vue&type=script&lang=js&"
export * from "./resport.vue?vue&type=script&lang=js&"
import style0 from "./resport.vue?vue&type=style&index=0&id=5b2f69c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f69c4",
  null
  
)

export default component.exports